import React from 'react';
import { LogoChip, Reveal, SlideFrame, t } from './primitives';
import { StoryboardButton } from './Storyboard';
const AGENDA = ['Why we exist', 'The Roche learning', 'Proven LEO work', 'Delivery & cost', 'Control Tower', 'Operating model'];
const DELIVERED = [{
  brand: 'ANZUPGO®',
  work: 'Patient guide · UK & Spain campaigns'
}, {
  brand: 'TraloSpeak',
  work: 'KEE webinar series & Snak bundles'
}, {
  brand: 'LEO Pharma CHE',
  work: 'Website Snak video embeds'
}, {
  brand: 'DERMX',
  work: 'Webinar series — Leo Pharma UK'
}];
export function Cover() {
  return <SlideFrame data-id="element-79" data-mp="j80z8snsb7a1">
      <div aria-hidden className="absolute inset-x-0 top-0 z-10 h-[5px] bg-[#7D38E5]" data-id="element-80" data-mp="j7j5c2olh55a" />

      <div className="grid h-full w-full grid-cols-[1.6fr_1fr]" data-id="element-81" data-mp="n9w0xy9mnmoc">
        <div className="flex min-w-0 flex-col justify-between px-[4vw] pt-[4.4vh] pb-[3.8vh]" data-id="element-82" data-mp="n71g45mpbzue">
          <Reveal className="flex items-center gap-[1.2vw]" data-id="element-83" data-mp="1up0u9w1io07r">
            <LogoChip data-id="element-84" data-mp="1yn874fsv0hdo" />
            <span className={`${t.label} font-semibold uppercase tracking-[0.22em] text-white/50`} data-id="element-85" data-mp="1ymq5f3nfhayd">
              Client presentation
            </span>
          </Reveal>

          <div data-id="element-86" data-mp="drvptqshp4ls">
            <Reveal delay={0.1} data-id="element-87" data-mp="dp9my4gjnd9w">
              <p className={`${t.label} font-semibold uppercase tracking-[0.28em] text-[#A26BFF]`} data-id="element-88" data-mp="8r83hif7hbxw">
                Strategic campaign delivery
              </p>
            </Reveal>
            <Reveal delay={0.18} className="mt-[2.4vh] flex gap-[1.6vw]" data-id="element-89" data-mp="3vxqwr42ncakx">
              <span aria-hidden className="w-[6px] shrink-0 bg-[#7D38E5]" data-id="element-90" data-mp="3r5h075710c9o" />
              <h1 className={`${t.hero} font-semibold leading-[0.92] tracking-[-0.035em]`} data-id="element-91" data-mp="3r45vn35rb0hi">
                Snakker
                <span className="block text-white/35" data-id="element-92" data-mp="3h8ufqhim3n86">for LEO Pharma</span>
              </h1>
            </Reveal>
            <Reveal delay={0.3} data-id="element-93" data-mp="3d5oddkymeg6z">
              <p className={`${t.lead} mt-[3.2vh] max-w-[92%] leading-[1.3] text-white/70`} data-id="element-94" data-mp="3d80rfn19c6er">
                Global campaign masters, local activation, and one control layer —
                <span className="text-white" data-id="element-95" data-mp="2yi7hw76v039s">
                  {' '}
                  agency-quality output at a fundamentally different cost base.
                </span>
              </p>
            </Reveal>
          </div>

          <Reveal delay={0.4} className="flex flex-wrap items-center gap-[0.7vw]" data-id="element-96" data-mp="2tkeeflwxxnd7">
            {AGENDA.map((item, index) => <span key={item} className={`${t.label} rounded-full border px-[1.1vw] py-[0.9vh] uppercase tracking-[0.16em] ${index === 0 ? 'border-[#7D38E5] bg-[#7D38E5]/20 text-white' : 'border-white/15 text-white/50'}`} data-id="element-97" data-mp="3h9qkwe0vvhbt" data-mpi={index}>
                {item}
              </span>)}
          </Reveal>
        </div>

        <Reveal delay={0.24} className="flex min-w-0 flex-col justify-between bg-[#7D38E5] px-[2.6vw] pt-[4.4vh] pb-[3.8vh]" data-id="element-98" data-mp="41vswfh7kj5s">
          <p className={`${t.label} font-semibold uppercase tracking-[0.24em] text-white/70`} data-id="element-99" data-mp="1tk2h8an506om">
            Already delivered for LEO
          </p>

          <ul className="flex flex-col" data-id="element-100" data-mp="1ojoixkbc8b3s">
            {DELIVERED.map((item, index) => <li key={item.brand} className={`py-[2.2vh] ${index === 0 ? '' : 'border-t border-white/25'}`} data-id="element-101" data-mp="22f0ic50fupr1" data-mpi={index}>
                <p className={`${t.small} font-semibold leading-[1.15] text-white`} data-id="element-102" data-mp="1anuat3ie1prq">
                  {item.brand}
                </p>
                <p className={`${t.label} mt-[0.8vh] leading-[1.3] text-white/75`} data-id="element-103" data-mp="1jmxua8lgw76r">
                  {item.work}
                </p>
              </li>)}
          </ul>

          <div className="flex flex-col gap-[1.6vh]" data-id="element-104" data-mp="2v1l6kwlmalqd">
            <StoryboardButton tone="onAccent" label="View storyboard · PDF" data-id="element-105" data-mp="2v0a5j4jk3s2y" />
            <p className={`${t.label} uppercase tracking-[0.2em] text-white/70`} data-id="element-106" data-mp="2q39usgbri15i">
              Snakker · 2026
            </p>
          </div>
        </Reveal>
      </div>
    </SlideFrame>;
}